import { render, staticRenderFns } from "./child_productDetail_baner3.vue?vue&type=template&id=50ee5478"
import script from "./child_productDetail_baner3.vue?vue&type=script&lang=js"
export * from "./child_productDetail_baner3.vue?vue&type=script&lang=js"
import style0 from "./child_productDetail_baner3.vue?vue&type=style&index=0&id=50ee5478&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports